import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import RevolutionizeImg from "../../images/location_new/fold7/Ohio.webp";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Revolutionize(props) {
  return (
    <div className="revolutionize_section">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>Why Choose TekRevol for Mobile App Development in Ohio?</h2>
            <p>
              TekRevol is a great choice when it comes to Mobile App Development
              in Ohio. Having a firm grip on strong methodologies and innovative
              technologies, we ensure the seamless development of various mobile
              apps. With a well-established history of delivering outstanding
              mobile apps that have received industry recognition and achieved
              notable success. Our team excels at crafting customized mobile
              apps that precisely align with your unique business objectives. We
              consistently lead in mobile technology trends, employing the
              latest tools and frameworks to create innovative and future-proof
              apps. Meanwhile, our agile development methodology ensures rapid
              iterations, swift outcomes, and adaptability to evolving
              requirements.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="revolutionize_img"
          >
            <LazyLoadImage
              src={RevolutionizeImg}
              effect="blur"
              alt="Image"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Revolutionize;
